import React from 'react'

import {ScrollMobileButtonDotActive, ScrollMobileButtonDot} from './Scroller.styles'

const ScrollMobileDot = ({active, handleClick}) => {
  if (active) {
    return (<ScrollMobileButtonDotActive />)
  }

  return (<ScrollMobileButtonDot onClick={handleClick} />)
}

export default ScrollMobileDot
